import {
	Backdrop,
	createStyles,
	Fade,
	makeStyles,
	Modal,
	Theme,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Warning from "../../../assets/kinologyIcons/svg/warningForgot.svg";
import {ReactComponent as Close} from "../../../assets/kinologyIcons/svg/close.svg";
import { FinancialActions } from "../../../store/ducks/financial";
import { ActivityIndicator } from "../../../components/Buttons/FormSubmitButton/style";
import { FaturaProps } from "../../../interfaces/cartao.interface";
import { Colors } from "../../../styles/colors";
import { DashBoardActions } from "../../../store/ducks/dashboard";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0",
			boxShadow: theme.shadows[5],
		},
	})
);

const ModalEscolhaFormaPagamento: React.FC = () => {
	const dispatch = useDispatch();
	const classes = useStyles();

	const current_language = useSelector(
		(state: any) => state.configs.current_language
	);
	const load = useSelector((state: any) => state.financial.loading_card);

	const modalVisible = useSelector(	(state: any) => state.financial.modal_escolha_forma_pagamento);
	const dataFaturaAtual: FaturaProps = useSelector(	(state: any) => state.financial.modal_pagamento_cartao_data);
	const config_servicos = useSelector((state: any) => state.configs.config_servicos);
	const faturas: FaturaProps[] = useSelector((state: any) => state.financial.faturas);

	const [ loadButton, setLoadButton] = useState<{load: boolean, type: 'pix' | 'card' | 'bank_slip' | ''}>({load: false, type:''})

	const handleClose = () => {
	dispatch(FinancialActions.set_modal_escolha_pagamento(false))
	dispatch(DashBoardActions.set_current_page('pagamentos'))
	};
	
	useEffect(()=>{
		if(!modalVisible){
			setLoadButton({load: false, type: ''})
		}
	},[modalVisible])



	return (
		<Modal
			aria-labelledby="transition-modal-title"
			aria-describedby="transition-modal-description"
			className={classes.modal}
			open={modalVisible}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500,
			}}
		>
			<Fade in={modalVisible}>
				<ModalContainer>
					<ModalContent>
						<CloseButton onClick={handleClose}>
							<Close width={18} height={18} style={{right:5, top:10,  position: 'absolute'}}/>
						</CloseButton>
						<IconContainer>
							<img style={{ width: "4rem", height: "4rem" }} src={Warning} />
						</IconContainer>
						<Title>{current_language?.como_efetuar_pagamento}</Title>
						<Title style={{fontWeight:'400' }}>{current_language?.troca_metodo_pagamento_cartao}</Title>

						<Button 
							onClick={() => {
								setLoadButton({load: true, type: 'card'})
								dispatch(FinancialActions.set_change_type_form_payment('card'));
								dispatch(	DashBoardActions.set_current_page("adicionar_pagamento"));
								dispatch(FinancialActions.set_modal_escolha_pagamento(false))
							}}
							style={{
								display:  "flex",
								alignItems: 'center',
								backgroundColor: '#009973',
								color: '#FFFFFF',
								justifyContent: 'center'
							}}
						>
							{loadButton.load && loadButton.type === 'card'
								? <ActivityIndicator  style={{height: 18, width: 18}} />
								:	current_language?.pagar_cartao
							}
						</Button>

						<Button 
							style={{display: 'none'}}
							onClick={() =>{
								dispatch(FinancialActions.set_change_type_form_payment('pix'));
								dispatch(FinancialActions.alterar_forma_pagamento_request({
									SERVICO_SUPERLOGICA: String(config_servicos?.SERVICO_SUPERLOGICA),
									FORMA_PAGAMENTO: 'pix',
									FATURAS: [faturas?.[faturas.length -1]?.ID_FATURA]
								}))
								setLoadButton({load: true, type: 'pix'})

							}}
						>
							{
								loadButton.load && loadButton.type === 'pix'
								? <ActivityIndicator  style={{height: 18, width: 18}} />
								: current_language?.pagar_por_pix
							}
						
						</Button>

						<Button 
							style={{display: 'none'}}
							onClick={() =>{
								dispatch(FinancialActions.set_change_type_form_payment('bank_slip'));
								dispatch(FinancialActions.alterar_forma_pagamento_request({
									SERVICO_SUPERLOGICA: String(config_servicos?.SERVICO_SUPERLOGICA),
									FORMA_PAGAMENTO: 'bank_slip',
									FATURAS: [faturas?.[faturas.length -1]?.ID_FATURA]
								}))
								setLoadButton({load: true, type: 'bank_slip'})
							}}
						>
							{loadButton.load && loadButton.type === 'bank_slip'
								? <ActivityIndicator  style={{height: 18, width: 18}} />
								: current_language?.pagar_por_boleto
							}
						</Button>
					
					</ModalContent>
				</ModalContainer>
			</Fade>
		</Modal>
	);
};

const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
`;

const ModalContent = styled.div`
	background: white;
	padding: 20px;
	border-radius: 0.75rem;
	max-width: 25%;
	width: 100%;
	text-align: center;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
	position: relative;
`;

const CloseButton = styled.button`
	position: absolute;
	top: 10px;
	right: 10px;
	background: none;
	border: none;
	font-size: 30px;
	cursor: pointer;
`;

const IconContainer = styled.div`
	margin-bottom: 16px;
	margin-top: 16px;
`;

const Title = styled.h2`
	font-size: 16px;
	color: #002060;
	margin: 0 0 16px;
`;

const Button = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	padding: 12px;
	font-size: 14px;
	font-weight: 400;
	color: ${Colors.neutral_grey_k_70};
	background-color: white;
	border: 1px solid #009973;
	border-radius: 0.75rem;
	margin-bottom: 8px;
	cursor: pointer;
	&:hover {
		background-color: #f6f6f6;
	}
`;

export default ModalEscolhaFormaPagamento;
